var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',[_c('lennoc-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.busy),expression:"busy"}],attrs:{"isFullscreen":"false"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }